import { string as yupString, object as yupObject } from 'yup';
import error from './ErrorMessage';

// const phoneRegExp = /^((\+44\s?\d{4}|\(?\d{5}\)?)\s?\d{6})|((\+44\s?|0)7\d{3}\s?\d{6})$/;

const fieldSchema = yupObject().shape({
	email: yupString()
		.required(error.email)
		.email(error.validEmail),
	name: yupString()
		.required(error.fullName)
		.max(50, error.maxLength)
		.matches(/^[a-zA-Z'-]+$/, error.invalidCharacters),
	lname: yupString()
		.required(error.lname)
		.max(50, error.maxLength)
		.matches(/^[a-zA-Z'-]+$/, error.invalidCharacters),
	// telephone: yupString()
	// 	// .matches(phoneRegExp, error.validNumber)
	// 	// .length(13),
	// 	.required(error.telephone)
	// 	.matches(phoneRegExp, error.validNumber),
});
export default fieldSchema;
